require('./Forms/DiabeticAssessment/Scripts/DiabeticAssessmentForm');
